
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[legalUid]",
      function () {
        return require("private-next-pages/legal/[legalUid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[legalUid]"])
      });
    }
  